import React, { Component } from 'react';
import FooterCom from './components/Footer';
import HeaderCom from './components/Header';
import { PanoramicStore } from './mobx/exportMobx';
import 'antd-mobile/dist/antd-mobile.css';

class App extends Component {

  UNSAFE_componentWillMount = () => {
    // 为了解决微信不能二次分享的问题，重定向url
    var _href = window.location.href;
    if (_href.indexOf('?') > -1) window.location.href = window.location.href.split('?')[0];
    PanoramicStore.getSignature();
  }

  componentDidMount = () => {
    window.wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
      window.wx.updateAppMessageShareData({
        title: '翔顺筠州小镇VR全景微沙盘', // 分享标题
        desc: '这世界上有千万种等待，最好的那种叫做来日可期。', // 分享描述
        link: 'https://www.frontopbd.com/JZXZ', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://www.frontopbd.com/JZXZ/logo.png', // 分享图标
      })

      window.wx.updateTimelineShareData({
        title: '翔顺筠州小镇VR全景微沙盘', // 分享标题
        link: 'https://www.frontopbd.com/JZXZ/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://www.frontopbd.com/JZXZ/logo.png', // 分享图标
      })
    });
  }

  render() {
    return (
      <div className="App" style={{ display: 'flex', width: '100vw', height: '100vh' }}>
        <HeaderCom />
        <FooterCom />
      </div>
    );
  }

}

export default App;
